import { Routes } from '@angular/router';

import { environment } from '../environments/environment';
import { MpsLoggedInGuard } from '../mps/guards/mps-loggedin.guard';
import { ExternalRedirectComponent } from './shared/components/external-redirect/external-redirect.component';
import { globalRouteNames } from './shared/global-route-names';
import { canActivateAdministration, canMatchAdministration } from './shared/guards/administration.guard';
import { canActivateHome, canMatchHome } from './shared/guards/home.guard';
import { canActivateUserManagement, canMatchUserManagement } from './shared/guards/user-management.guard';

export const applicationRoutes: Routes = [
  {
    path: globalRouteNames.home,
    loadChildren: () => import('./modules/home/home.routes').then((m) => m.homeRoutes),
    data: { title: 'general.navigation.home' },
    canActivate: [canActivateHome],
    canMatch: [canMatchHome],
  },
  {
    path: globalRouteNames.ongoingRequests,
    data: { title: 'general.navigation.ongoing_requests.menu_title' },
    children: [
      {
        path: 'fc-requests',
        loadChildren: () => import('./modules/fc-requests/fc-requests.routes').then((m) => m.fcRequestsRoutes),
        data: { title: 'general.navigation.ongoing_requests.fc_requests' },
        canActivate: [MpsLoggedInGuard],
      },
      {
        path: 'fi-requests',
        loadChildren: () => import('./modules/fi-requests/fi-requests.routes').then((m) => m.fiRequestsRoutes),
        data: { title: 'general.navigation.ongoing_requests.fi_requests' },
        canActivate: [MpsLoggedInGuard],
      },
    ],
  },
  {
    path: globalRouteNames.reporting,
    data: { title: 'general.navigation.reporting.title' },
    children: [
      {
        path: 'fc-reporting',
        component: ExternalRedirectComponent,
        data: {
          icon: 'description',
          title: 'general.navigation.reporting.fiche_client',
          externalLink: environment.reporting.fcReportingLink
        },
      },
      {
        path: 'fi-reporting',
        component: ExternalRedirectComponent,
        data: {
          icon: 'request_quote',
          title: 'general.navigation.reporting.invoice',
          externalLink: environment.reporting.fiReportingLink
        },
      },
      {
        path: 'scope-variation-reporting',
        component: ExternalRedirectComponent,
        data: {
          icon: 'difference',
          title: 'general.navigation.reporting.scope_variation',
          externalLink: environment.reporting.svReportingLink
        },
      }
    ],
  },
  {
    path: globalRouteNames.userManagement,
    loadChildren: () => import('./modules/user-management/user-management.routes').then((m) => m.userManagementRoutes),
    data: { title: 'general.navigation.user_management' },
    canActivate: [MpsLoggedInGuard, canActivateUserManagement],
    canMatch: [canMatchUserManagement],
  },
  {
    path: globalRouteNames.admin,
    loadChildren: () => import('./modules/admin/admin.routes').then((m) => m.adminRoutes),
    data: { title: 'general.navigation.admin' },
    canActivate: [MpsLoggedInGuard, canActivateAdministration],
    canMatch: [canMatchAdministration],
  },
];
